/**
 * Created by elmar on 01/27/2017.
 */

(function($) {
    'use strict';

    (new function() {
        var __body_id = '#page__companies_users_index';
        var __table   = '#dt-table';

        var SEARCH_ROW = {};
        var COLUMNS    = [
            {
                data        : 'name',
                title       : 'Name',
                orderable   : true,
                className   : 'text-left',
                customsearch: true
            },
            {
                data        : 'email',
                title       : 'Email',
                orderable   : true,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : 'role',
                title       : 'Role',
                orderable   : true,
                className   : 'text-center',
                customsearch: true,
                render      : function(data, type, row) {
                    return '<span class="label label-success">' + data + '</span>';
                }
            },
            {
                data        : 'created_at',
                title       : 'Registration date',
                orderable   : true,
                className   : 'text-center',
                customsearch: true
            },
            {
                data        : '',
                orderable   : false,
                className   : 'text-right',
                customsearch: false,
                render      : function(data, type, row) {
                    var $html = '';

                    if (window.PERMISSIONS.company_users__edit) {
                        $html += ' <a href="/companies/' + row.company_id + '/users/' + row.id + '/edit" class="btn btn-default btn-sm" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Edit">' +
                                 '<i class="fa fa-pencil"></i>' +
                                 '</a>';
                    }

                    var can_delete = true;

                    if (window.USER_ID == row.id) {
                        can_delete = false;
                    }

                    if (row.company_owner_id == row.id) {
                        can_delete = false;
                    }

                    if (!window.PERMISSIONS.company_users__delete) {
                        can_delete = false;
                    }

                    if (can_delete) {
                        $html += ' <a href="/companies/' + row.company_id + '/users/' + row.id + '/delete" class="btn btn-danger btn-sm" ' +
                                 'data-method="delete" data-confirm="Are you sure?" data-token="' + window.TOKEN + '" ' +
                                 'data-toggle="tooltip" data-placement="bottom" title="Delete">' +
                                 '<i class="fa fa-times"></i>' +
                                 '</a>';
                    }

                    return $html;
                }
            }
        ];

        /**
         ***************************************************************************
         * Init
         ***************************************************************************
         */
        this.init = function() {
            if (!$(__body_id).length) {
                return false;
            }

            COLUMNS.forEach(function(element, index) {
                if (element.customsearch) {
                    SEARCH_ROW[ element.data ] = '';
                }
            });

            __assignEvents();
        };

        /**
         ***************************************************************************
         * Events
         ***************************************************************************
         */
        var __assignEvents = function() {
            $.fn.dataTableExt.sErrMode = "console";

            __initTable();
        };

        var __initTable = function() {
            $(__table)
                .on('processing.dt', function(e, settings, processing) {
                    if (processing) {
                    } else {
                        initBaseFunctions();
                    }
                })
                .on('length.dt', function(e, settings, len) {
                    set_page_length('companies_users_index', len);
                })
                .DataTable({
                    "dom"         : '<"row"' +
                                    '<"col-md-8"i>' +
                                    '<"col-md-4 text-right"l>' +
                                    '>' +
                                    '<"row dt-table"' +
                                    '<"col-md-12"tr>' +
                                    '>' +
                                    '<"row"' +
                                    '<"col-md-8"i>' +
                                    '<"col-md-4 text-right"p>' +
                                    '>',
                    "lengthChange": true,
                    "lengthMenu"  : [ [ 10, 25, 50, 100, 250, 500 ], [ 10, 25, 50, 100, 250, 500 ] ],
                    "pageLength"  : get_page_length('companies_users_index'),
                    "filter"      : false,
                    "searching"   : false,
                    "pagingType"  : 'full_numbers',
                    "processing"  : true,
                    "serverSide"  : true,
                    "order"       : [ [ 0, 'asc' ] ],
                    "columns"     : COLUMNS,
                    initComplete  : function() {
                        if (!$(this).find('thead').find('.row-filter').length) {
                            var $rowFilter = '<tr class="row-filter">';

                            COLUMNS.forEach(function(element, index) {
                                $rowFilter += '<td>';

                                if (element.customsearch) {
                                    $rowFilter += '<input type="text" class="form-control fc-input-sm fc-block js-search-field" data-field="' + element.data + '">';
                                }

                                $rowFilter += '</td>';
                            });

                            $rowFilter += '</tr>';

                            $(this).find('thead').append($rowFilter);
                        }
                    },
                    ajax          : function(data, callback, settings) {
                        data.search_row = SEARCH_ROW;

                        $.ajax({
                            url    : window.location.href,
                            data   : data,
                            success: function(response) {
                                callback(response);
                            }
                        });
                    }
                });

            $(__body_id).on('keyup', __table + ' thead .row-filter .js-search-field', function(e) {
                __collectSearches();
            });
        };

        var __collectSearches = function() {
            $(__table + ' thead .row-filter .js-search-field').each(function() {
                var $input = $(this);

                SEARCH_ROW[ $input.data('field') ] = $input.val().trim();
            });

            setTimeout(function() {
                $(__table).DataTable().draw()
            }, 100);
        };

    }).init();

})(jQuery);